/**
 * There are a lot of ways to determine if a number is really a number, using IsNaN is *not* enough for most checks
 *
 * @see https://stackoverflow.com/questions/18082/validate-decimal-numbers-in-javascript-isnumeric/1830844#1830844
 */
export class IkeNumber {
	/**
	 * Determine if this number is real number
	 *
	 * Eg not : NaN, Infinity
	 *
	 * @param n Number/String/any to check
	 * @returns Whether the number is really a number
	 */
	static isNumber(n: any): boolean {
		return !isNaN(parseFloat(n)) && isFinite(n);
	}
	/**
	 * Attempt to convert a string to a number
	 *
	 * Return null if the string is not a real number, eg NaN/Infinity
	 *
	 * @param s String to check
	 * @returns Parsed float value or null
	 */
	static toNumber(s: string): number | null {
		if (IkeNumber.isNumber(s)) {
			return parseFloat(s);
		}
		return null;
	}
}
